import { red } from '@ant-design/colors'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ButtonProps } from 'antd'

export type Props = Exclude<ButtonProps, 'type'>
export const DeleteButton = (props: Props) => {
  return <Button style={{color: red.primary}} icon={<FontAwesomeIcon icon={faTrash} />} {...props} type="text" />
}

export default DeleteButton